import { render, staticRenderFns } from "./KidsGolfPreRegister.vue?vue&type=template&id=da3eb234&scoped=true"
import script from "./KidsGolfPreRegister.vue?vue&type=script&lang=js"
export * from "./KidsGolfPreRegister.vue?vue&type=script&lang=js"
import style0 from "./KidsGolfPreRegister.vue?vue&type=style&index=0&id=da3eb234&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3eb234",
  null
  
)

export default component.exports